import { render, staticRenderFns } from "./Representatives.vue?vue&type=template&id=4721204a&scoped=true&"
import script from "./Representatives.vue?vue&type=script&lang=js&"
export * from "./Representatives.vue?vue&type=script&lang=js&"
import style0 from "./Representatives.vue?vue&type=style&index=0&id=4721204a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4721204a",
  null
  
)

export default component.exports